import { render } from "./htmlEditor.vue?vue&type=template&id=60ca706a"
import script from "./htmlEditor.vue?vue&type=script&lang=js"
export * from "./htmlEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__